import React from 'react';
import './toast.scss'; // 你可以自己定义样式
import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
interface ToastProps {
  message: string;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, onClose }) => {
  return (
    <div className="toast">
      <div className="toast-content">
        <div className="toast-top">
            <div className="toast-title"><InfoCircleOutlined style={{ fontSize: '16px', color: '#FC363B' }} /><span style={{ marginLeft: '6px' }}>Notice</span></div>
            <CloseOutlined  style={{ fontSize: '16px', cursor: 'pointer', color: 'rgba(0, 0, 0, 0.45)' }} onClick={onClose}/>
        </div>
        <div className="toast-content-message">
          {message}
        </div>
      </div>
    </div>
  );
};

export default Toast;